'use client';

import { type ReactNode } from 'react';
import { env } from '@/config/env';
import {
  EvaluationOptions,
  FeatureFlagProvider,
  FlagValue,
  useFeatureFlagContext,
  useFlag,
} from '@upms/feature-flags';

// see, https://app.launchdarkly.com/projects/upms-online-account
type AppFeature = 'feature-upms-live';

interface Props {
  children: ReactNode;
}

export function FeatureProvider({ children }: Props) {
  return (
    <FeatureFlagProvider
      // connect with LaunchDarkly before knowing context to allow for general / common feature flags
      context={undefined}
      defaultEvaluationOptions={{
        suspend: false,
        updateOnContextChanged: true,
        updateOnConfigurationChanged: true,
      }}
      launchDarklyConfig={{ clientKey: env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_KEY }}
      // Todo(EE-56): onError
    >
      {children}
    </FeatureFlagProvider>
  );
}

export const useFeature = <T extends FlagValue>(
  flagKey: AppFeature,
  defaultValue: T,
  options?: EvaluationOptions
) => {
  return useFlag<T>(flagKey, defaultValue, options);
};

export const useFeatureContext = useFeatureFlagContext;
